module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Short Name",
            "field": "shortname",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Name",
            "field": "name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Name",
            "field": "payment_holder_name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder IBAN",
            "field": "payment_holder_iban",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Swift",
            "field": "payment_holder_swift",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Holder Address",
            "field": "payment_holder_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Bank Address",
            "field": "payment_bank_address",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Payment Amount",
            "field": "payment_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a6cfda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/University/Detail.vue
// module id = 704
// module chunks = 1